import { ApiService } from '@/services/api.service'
import { getOneTimeParams } from '@/utils/helpers'

const BaseUrl = '/categories'

const payload = (params) => ({
  ...params,
  ...getOneTimeParams()
})

export function listTitle (params = {}) {
  return ApiService.get(`${BaseUrl}`, payload(params)).then((resp) => resp)
}

export function getListCate (id, params = {}) {
  return ApiService.get(`${BaseUrl}/${id}/advertises`, payload(params)).then((resp) => resp)
}
